// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"e98351cbce546e48","567":"fb3f6baf023dae27","736":"ed034478420d7efa"}[chunkId] + ".js";
};